<div class="container single-view" id="add-distribution-channel">
  <div class="row">
    <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
      <div id="pre-header-wr">
        <a data-testid="back-btn" routerLink="/distribution-channels/" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'DISTRIBUTION_CHANNELS.BTN_BACK_TO_DISTRIBUTION_CHANNEL' | translate }}</a>
      </div>
    </div>
    <div class="col-12">
      <div id="view-header-wr" class="flex flex-wrap items-end justify-between gap-4">
        <div class="title-wr">
          <h1 data-testid="add-distributionchannel-title" class="section-title">{{ 'DISTRIBUTION_CHANNEL_CREATE.TITLE' | translate }}</h1>
          <p data-testid="add-distributionchannel-subtitle" class="section-subtitle mt-1 text-base">{{ 'DISTRIBUTION_CHANNEL_CREATE.SUBTITLE' | translate }}</p>
        </div>
        <div class="actions-wr"></div>
      </div>
      <hr role="presentation" class="w-full mb-3 mt-6 border-t">
      <div class="view-content-wr">
        <div class="row">
          <div class="flex flex-col col-12 mb-2 text-wr">
            <!-- main content -->
            <form class="mt-0" [formGroup]="distributionChannelForm" data-testid="add-distributionchannel-form">
              <div class="row">
                <div class="flex flex-col col-12 mb-4">
                  <h2 class="border-b pb-3">{{ 'DISTRIBUTION_CHANNEL_CREATE.DISTRIBUTION_CHANNEL_DETAILS' | translate }}</h2>
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label data-testid="add-distributionchannel-field-name" class="block text-sm" for="name">{{ 'DISTRIBUTION_CHANNEL_CREATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-distributionchannel-name-input" type="text" id="name" formControlName="name" autocomplete="off">
                  @if (distributionChannelForm.get('name')?.invalid && distributionChannelForm.get('name')?.touched) {
                    <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
                <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                  <label  data-testid="add-distributionchannel-field-code" class="block text-sm" for="code">{{ 'DISTRIBUTION_CHANNEL_CREATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                  <input data-testid="add-distributionchannel-code-input" type="text" id="code" formControlName="code" autocomplete="off">
                  @if (distributionChannelForm.get('code')?.invalid && distributionChannelForm.get('code')?.touched) {
                    <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                  }
                </div>
              </div>
              <div class="row">
                <div class="col-12 mt-6 mb-4 pt-8 border-t">
                  <div class="flex items-center justify-end gap-3">
                    <button data-testid="add-distributionchannel-create-distributionchannel-button" class="btn primary-btn" [disabled]="distributionChannelForm.invalid"
                      (click)="submitForm()">{{
                    'DISTRIBUTION_CHANNEL_CREATE.BTN_CREATE_DISTRIBUTION_CHANNEL' | translate }}</button>
                  </div>
                </div>
              </div>
            </form>
            <!-- /main content -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
